"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _react = require("react");
var _debounce = _interopRequireDefault(require("./debounce"));
var _useResizeObserver2 = _interopRequireDefault(require("./useResizeObserver"));
var useOverflowDetector = function useOverflowDetector(targetRef) {
  var _context;
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hasOverflow = _useState2[0],
    setHasOverflow = _useState2[1];
  var internalRef = (0, _react.useRef)(null);
  if (targetRef) {
    internalRef = targetRef;
  }
  var _useResizeObserver = (0, _useResizeObserver2.default)({
      targetRef: internalRef
    }),
    targetWidth = _useResizeObserver.width;
  var checkOverflow = (0, _debounce.default)(function () {
    var targetEl = internalRef.current;
    if (targetEl) {
      setHasOverflow(targetEl.scrollWidth > targetEl.clientWidth);
    }
  });
  (0, _react.useEffect)(function () {
    checkOverflow();
  }, (0, _concat.default)(_context = []).call(_context, (0, _toConsumableArray2.default)(deps), [targetWidth]));
  return {
    checkOverflow: checkOverflow,
    hasOverflow: hasOverflow,
    ref: internalRef
  };
};
var _default = useOverflowDetector;
exports.default = _default;